import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-04_recruitment_quality",
  "use": "icon-04_recruitment_quality-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-04_recruitment_quality\"><path d=\"M11.996 11.72L8.078 7.15l-1.139.975 5.057 5.9 5.058-5.9-1.139-.976-3.918 4.572z\" /><path d=\"M18.927 2.04H5.066L1.084 8.866l10.913 13.096L22.91 8.866 18.927 2.04zM2.91 8.714L5.928 3.54h12.138l3.018 5.174-9.087 10.905L2.909 8.714z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol